import InputField from 'components/fields/InputField';

const BranchUpdateModel = ({
  updatedBranch,
  setUpdatedBranch,
  setShowUpdateModal,
  handleUpdateBranch,
}) => {
  return (
    <div className="bg-black fixed inset-0 flex items-center justify-center bg-opacity-50">
      <div className="relative mx-4 w-full max-w-md rounded-lg bg-white p-4 text-gray-800 shadow-xl dark:bg-navy-800 md:mx-0 md:p-8">
        <button
          type="button"
          onClick={() => setShowUpdateModal(false)}
          className=" absolute right-2 top-2 h-10 w-8 rounded-full text-3xl text-brand-900 transition duration-200 dark:text-brand-900 dark:text-navy-200"
        >
          &times;
        </button>
        <h2 className="mb-4 text-lg font-medium dark:text-navy-200">
          Update Branch Details
        </h2>
        <form>
          <div className="mb-4">
            <InputField
              label="Name"
              type="text"
              value={updatedBranch?.name || ''}
              onChange={(e) =>
                setUpdatedBranch({
                  ...updatedBranch,
                  name: e.target.value,
                })
              }
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50 sm:text-sm"
            />
          </div>
          <div className="mb-4">
            <InputField
              label="Location"
              type="text"
              value={updatedBranch?.location || ''}
              onChange={(e) =>
                setUpdatedBranch({
                  ...updatedBranch,
                  location: e.target.value,
                })
              }
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50 sm:text-sm"
            />
          </div>

          <div className="flex justify-end">
            <button
              onClick={handleUpdateBranch}
              className="w-40 rounded-xl bg-brand-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BranchUpdateModel;
